import React from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import { initializeNativeShell } from '@/platform/appBoot'
import { initializeTelemetry } from '@/platform/telemetry'
import '@/styles/application.css'

void initializeTelemetry()

const container = document.getElementById('react-root')
if (container) {
  const root = createRoot(container)
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
  void initializeNativeShell()
}
